<div @fadeInUp class="upload-files-container">
	<cds-select
		label="Select Fund"
		[(ngModel)]="currentDeal"
		(valueChange)="onDealSelected($event)"
	>
		<option *ngFor="let deal of userData['Deals']" [value]="deal['Deal Name']">{{deal['Deal Name']}}</option>
	</cds-select>

	<cds-file-uploader
		[drop]="true"
		[multiple]=true
		(filesChange)="onFilesSelected($event)"
		[dropText]="'Drag and drop files here or upload'"
	>
	</cds-file-uploader>

	<div class="selected-files" *ngIf="currentFiles.length" style="padding-top: 16px; margin-bottom: -8px">
		<ng-container *ngFor="let fileItem of currentFiles; let i = index">
			<div class="row">
				<cds-file
					size="md"
					class="sub-div"
					[fileItem]="fileItem"
					(remove)="removeFile(fileItem)"
				>
				</cds-file>
				<div class="sub-div">
					<cds-combo-box
						type="multi"
						[items]="fileTypeItems"
						placeholder="Select File Types"
						[invalid]="fileItem['File Types Invalid']"
						(selected)="onSelectFileTypes(i, $event)"
					>
					  <cds-dropdown-list></cds-dropdown-list>
					</cds-combo-box>
				</div>
				<div class="sub-div" style="max-width: calc((100% - 16px)/3) !important;">
					<cds-date-picker
						placeholder="Select Reference Date"
						[invalid]="fileItem['Reference Date Invalid']"
						(valueChange)="onReferenceDateSelected(i, $event)"
						style="max-width: calc((100% - 16px)/3) !important; width: calc((100% - 16px)/3) !important; min-width: calc((100% - 16px)/3) !important"
					></cds-date-picker>
				</div>
			</div>
		</ng-container>
	</div>

	<cds-button-set>
		<button size="xl" cdsButton="primary" (click)="onUploadFiles()">
			Upload Files
			<svg class="cds--btn__icon" cdsIcon="document--add" size="16"></svg>
		</button>
	</cds-button-set>
</div>
